import { BaseAction } from '../../store/actions';
import { RegisterApiOptions, RegisterStatus } from '../../shared/models/register';

export enum RegisterActions {
  RegisterRequest = '[Register] Start Register',
  RegisterSuccess = '[Register] Register Success',
  RegisterError = '[Register] Register Error',
}

export class RegisterRequest implements BaseAction<RegisterActions> {
  readonly type = RegisterActions.RegisterRequest;

  constructor(public readonly apiOptions: RegisterApiOptions) {}
}

export class RegisterSuccess implements BaseAction<RegisterActions> {
  readonly type = RegisterActions.RegisterSuccess;

  constructor(public readonly payload: RegisterStatus) {}
}

export class RegisterError implements BaseAction<RegisterActions> {
  readonly type = RegisterActions.RegisterError;

  constructor(public readonly payload: RegisterStatus) {}
}

export type RegisterAction = RegisterRequest | RegisterSuccess | RegisterError;